
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/lifestyle",
      function () {
        return require("private-next-pages/sneakers/lifestyle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/lifestyle"])
      });
    }
  